<template>
  <div>
    <div
      class="blog__hero--container"
      style="background-image: url('/img/banner_products.jpg');">
      <h1>
        <a
          class="blog__hero--link"
          href="/blog">Aqua Bed Warmer Blog</a>
      </h1>
      <p>Latest Aqua Bed Warmer news and updates</p>
    </div>

    <div
      v-if="mainPost"
      class="blog clear">
      <div class="blog__archive">
        <div
          :style="`background:url('${mainPost.custom_fields.featured_image.url}');`"
          class="blog__archive--main-image-container"
        >
          <nuxt-link
            :to="`/blog/${mainPost.custom_fields.frontend_slug}`"
            class="featured-image-link"
          ></nuxt-link>
        </div>

        <div class="blog__archive--main-post-content">
          <div class="blog__meta">
            <span>{{ getDisplayDate(mainPost.post_date) }}</span>
          </div>

          <h2>
            <nuxt-link
              :to="`/blog/${mainPost.custom_fields.frontend_slug}`"
            >{{ mainPost.custom_fields.display_title }}</nuxt-link>
          </h2>
          <p>{{ mainPost.post_excerpt }}</p>
          <nuxt-link
            :to="`/blog/${mainPost.custom_fields.frontend_slug}`"
            class="blog__archive--main-post-link"
          >Read More</nuxt-link>
        </div>
      </div>

      <div
        v-if="subPosts"
        class="blog__grid">
        <article
          v-for="(subPost, postIndex) in subPosts"
          v-if="postIndex <= 9"
          :key="postIndex"
          class="blog__grid--item"
        >
          <nuxt-link :to="`/blog/${subPost.custom_fields.frontend_slug}`">
            <div
              :style="`background-image:url('${subPost.custom_fields.featured_image.url}');`"
              class="blog__grid--image-container"
            ></div>
          </nuxt-link>

          <div class="blog__meta">
            <span>AquaBed News&nbsp;&nbsp;|&nbsp;&nbsp;{{ getDisplayDate(subPost.post_date) }}</span>
          </div>

          <h2>
            <nuxt-link
              :to="`/blog/${subPost.custom_fields.frontend_slug}`"
            >{{ subPost.custom_fields.display_title }}</nuxt-link>
          </h2>
          <p>{{ subPost.post_excerpt }}</p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'BlogPosts',
  head () {
    return {
      title: 'AquaBed Blog',
      meta: [
        { hid: 'description', name: 'description', content: 'AquaBed Warmer Blog.' }
      ]
    }
  },
  computed: {
    ...mapGetters('posts', {
      mainPost: 'mainPost',
      subPosts: 'subPosts'
    })
  },
  methods: {
    getDisplayDate (postDate) {
      return moment(postDate).fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
.blog__category-link {
  a {
    color: #255b8b;
  }
}

.blog__hero--container {
  padding: 60px 8.5% 70px;
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  color: #fff;
  vertical-align: middle;

  h1 {
    margin: 0 0 10px 0;
    color: #fff;
  }

  p {
    margin: 0;
    font-size: 18px;
  }

  .blog__hero--link {
    color: inherit;
  }

  @media screen and (max-width: 807px) {
    padding: 45px 15px 45px;
  }
}

.blog__hero--article {
  padding: 30px 8.5% 40px;
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  color: #fff;
  vertical-align: middle;

  h1 {
    margin: 0 0 10px 0;
    color: #fff;
  }

  p {
    margin: 0;
    font-size: 18px;
  }

  @media screen and (max-width: 807px) {
    display: none;
  }
}

.blog {
  padding: 30px 30px;
  margin: 0 auto;
  max-width: 1100px;

  .attachment-full {
    min-width: 100%;
  }

  .blog__meta {
    margin: 14px 0;
    color: #dadada;

    span {
      font-size: 13px;
      color: #939393;

      @media screen and (max-width: 960px) {
        margin: 0 4px;
      }

      &:nth-child(1) {
        margin: 0 7px 0 0;

        @media screen and (max-width: 960px) {
          margin: 0 4px 0 0;
        }
      }
    }
  }

  @include e(breadcrumbs) {
    @include m(section) {
      width: 100;
      padding: 7px 8.5% 4px;
      border-top: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;

      ul {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
          display: inline-block;
          font-size: 0.73333em;
          font-weight: bold;
          vertical-align: top;

          a {
            font-weight: 400;
            color: #939393;

            &:hover {
              color: #255b8b;
              font-weight: 700;
            }
          }

          &:after {
            content: ">";
            margin-left: 0.57em;
            color: #939393;
            font-weight: 400;
          }

          &:nth-last-child(1) {
            margin-right: none;

            a {
              color: #255b8b;
              font-weight: bold;
            }

            &:after {
              content: "";
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 806px) {
    padding: 5px 8.5% 40px;
  }

  @include e(archive) {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid $grey;
    margin-bottom: 35px;
    margin-top: 30px;
    padding-bottom: 50px;

    @media screen and (max-width: 806px) {
      display: block;
    }

    @include m(main-image-container) {
      width: 50%;
      height: 372px;
      background-size: cover !important;
      background-position: center 15% !important;
      background-repeat: no-repeat !important;

      @media screen and (max-width: 806px) {
        width: 100%;
        height: 270px;
      }

      .featured-image-link {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    @include m(main-post-content) {
      width: 50%;
      bottom: 0;
      padding-left: 35px;

      h2 {
        font-weight: 700;
        line-height: 1em;
        font-size: 36px;
        margin-top: 1em;

        a {
          font-weight: 700;
        }
      }

      p {
        font-size: 15px;
        margin: 4px 0;
      }

      @media screen and (max-width: 806px) {
        width: 100%;
        padding-left: 0;

        h2 {
          font-weight: 700;
          line-height: 1em;
          font-size: 36px;
          margin: 0.4em 0;

          a {
            font-weight: 700;
          }
        }
      }
    }

    @include m(main-post-link) {
      color: $aqua-blue;
    }
  }

  .pagination {
    margin-top: 25px;
    @include clearfix;

    .page-numbers {
      padding: 12px 17px;
    }

    a {
      color: #c5c5c5;
      font-weight: 300;

      &:hover {
        color: #255b8b;
        font-weight: bold;
      }
    }
  }

  .pagination .current {
    color: #255b8b;
    font-weight: bold;
    border: 2px solid #255b8b;
    border-radius: 50%;
  }

  .pagination h2 {
    display: none;
  }

  .blog__grid {
    width: 100%;
    @include clearfix;
    display: flex;
    flex-flow: row wrap;

    .blog__grid--item {
      width: 32%;
      display: inline-block;
      margin: 15px 0 15px 2%;
      font-size: 15px;
      box-sizing: border-box;

      h2 {
        font-weight: 400;
        font-size: 22px;
        line-height: 1.3em;
        margin: 10px 0 5px 0;
      }

      p {
        margin: 0 0 10px 0;
        line-height: 1.5em;
        font-size: 15px;
      }

      @media screen and (max-width: 806px) {
        width: 49%;

        &:nth-child(odd) {
          margin-left: 0;
        }
      }

      @media screen and (max-width: 615px) {
        width: 100%;
        height: auto;
        margin: 15px 0 30px 2%;
        float: none;
        margin-left: 0;
      }

      .blog__grid--image-container {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 220px;
      }

      &:nth-child(1) {
        margin-left: 0;
      }

      @media screen and (min-width: 807px) {
        &:nth-child(4) {
          margin-left: 0;
        }

        &:nth-child(7) {
          margin-left: 0;
        }
      }
    }
  }

  @include e(grid-related) {
    @include m(item) {
      width: 32%;
      display: inline-block;
      margin: 15px 0 15px 2%;
      font-size: 15px;
      box-sizing: border-box;

      h2 {
        font-weight: 400;
        font-size: 22px;
        line-height: 1.3em;
        margin: 10px 0 5px 0;
      }

      p {
        margin: 0 0 10px 0;
        line-height: 1.5em;
        font-size: 15px;
      }

      @media screen and (max-width: 806px) {
        width: 100%;
        margin-left: 0;

        p {
          display: none;
        }

        h2 {
          margin: 0;
          font-size: 20px;
          line-height: 1em;
        }
      }

      @media screen and (max-width: 615px) {
        width: 100%;
        height: auto;
        margin: 15px 0 30px 2%;
        float: none;
        margin-left: 0;
      }

      &:nth-child(1) {
        margin-left: 0;
      }

      @media screen and (min-width: 807px) {
        &:nth-child(4) {
          margin-left: 0;
        }

        &:nth-child(7) {
          margin-left: 0;
        }
      }
    }

    @include m(image-container) {
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      width: 100%;
      height: 220px;

      @media screen and (max-width: 806px) {
        width: 40%;
        height: 145px;
        float: left;
      }
    }

    @include m(content) {
      width: 57%;
      float: left;
      margin-left: 3%;
    }
  }

  @include e(single) {
    @include m(main-image) {
      width: 100%;
      height: 455px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      margin-bottom: 25px;

      @media screen and (max-width: 807px) {
        height: 340px;
      }

      @media screen and (max-width: 615px) {
        height: 220px;
      }
    }

    @include m(article) {
      width: 100%;
      max-width: 700px;
      margin: auto;
      margin-bottom: 20px;
      padding-top: 15px;
      padding-bottom: 15px;

      h1 {
        font-size: 30px;
        font-weight: 700;
        line-height: 1.2em;
        margin: 0 0 0 0;
      }

      .entry-content {
        p {
          font-size: 15px;
          margin: 20px 0;
        }
      }

      @media screen and (max-width: 768px) {
        width: 100%;
        float: none;
      }
    }

    @include m(related) {
      border-top: 1px solid $grey;
      padding-top: 20px;

      @media screen and (max-width: 807px) {
        .blog__grid--image-container {
          height: 145px !important;
          width: 33%;
          float: left;
        }

        .blog__meta {
          display: none;
        }
      }
    }
  }

  .blog__share--container {
    margin: 20px 0 30px 0;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        display: inline-block;

        span {
          display: inline-block;
          padding: 10px;
          color: #fff;
          border-radius: 25px;
          width: 145px;
          text-align: center;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 1em;
          vertical-align: middle;

          i {
            margin-right: 7px;
            font-size: 1em;
            font-weight: 700;
            vertical-align: middle;
          }
        }

        .blog__share--facebook {
          background-color: #3b5998;
        }

        .blog__share--twitter {
          background-color: #00aced;
          margin-left: 15px;
        }
      }
    }
  }
}

.entry-header {
  padding-bottom: 20px;
}

.entry-content {
  ul {
    padding-left: 20px !important;
  }
}

.alignnone {
  margin: 5px 20px 20px 0;
}

.aligncenter,
div.aligncenter {
  display: block;
  margin: 5px auto 5px auto !important;
}

.alignright {
  float: right;
  margin: 5px 0 20px 20px !important;
}

.alignleft {
  float: left;
  margin: 5px 20px 20px 0 !important;
}

a img.alignright {
  float: right;
  margin: 5px 0 20px 20px;
}

a img.alignnone {
  margin: 5px 20px 20px 0;
}

a img.alignleft {
  float: left;
  margin: 5px 20px 20px 0;
}

a img.aligncenter {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.blog__mobile-category--nav {
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
    margin: 0 auto;
    min-width: 100%;
  }

  select {
    width: 100%;
    border: 1px solid #ccc;
  }
}

.desktop_featured_post {
  @media screen and (min-width: 615px) {
    display: block;
  }
  @media screen and (max-width: 615px) {
    display: none;
  }
}

.mobile_featured_post {
  @media screen and (min-width: 615px) {
    display: none;
  }
  @media screen and (max-width: 615px) {
    display: block;
    margin-bottom: 30px;

    h2 {
      font-weight: 300;
      font-size: 22px;
      line-height: 1.5em;
      margin: 15px 0 5px 0;
    }

    p {
      margin: 0 0 10px 0;
      line-height: 1.5em;
    }
  }
}
</style>
